var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckFilledActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.523438 24.9997C0.523438 31.492 3.10249 37.7183 7.69322 42.3091C12.284 46.8998 18.5103 49.4788 25.0026 49.4788C31.4949 49.4788 37.7213 46.8998 42.312 42.3091C46.9027 37.7183 49.4818 31.492 49.4818 24.9997C49.4818 18.5074 46.9027 12.281 42.312 7.69029C37.7213 3.09956 31.4949 0.520508 25.0026 0.520508C18.5103 0.520508 12.284 3.09956 7.69322 7.69029C3.10249 12.281 0.523438 18.5074 0.523438 24.9997Z",
    fill: "#EB2553"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7256 26.9609L18.1374 31.0969M22.5491 34.3138L36.2746 16.6667",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckFilledActive);
export default __webpack_public_path__ + "static/media/ic_check_filled_active.4a1a45e5ba6966f20710a7897f9e29bd.svg";
export { ForwardRef as ReactComponent };